import { render, staticRenderFns } from "./TellUsHere.vue?vue&type=template&id=1001d25f"
import script from "./TellUsHere.vue?vue&type=script&lang=js"
export * from "./TellUsHere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports